import React from 'react';
import {
    C,
    cardStyle, cardHeaderStyle, cardTitleStyle, labelStyle, valueStyle,
} from './shared';

const LANGUAGES = [{ value: 'en', labelKey: 'english' }, { value: 'ar', labelKey: 'arabic' }];

const FieldRow = ({ label, children }) => (
    <div>
        <label style={labelStyle}>{label}</label>
        <div style={valueStyle}>{children}</div>
    </div>
);

// ─── POS Access card ─────────────────────────────────────────────────────────

// SECURITY: the API returns `access.has_pin` (a boolean), never `pin_code` —
// see backend/tests/test_employee_pin_not_in_responses.py. So this card shows
// only whether a PIN is configured, with no reveal control.
const PosAccessCard = ({ employee, t }) => {
    const a = employee.access || {};
    return (
        <div style={cardStyle}>
            <div style={cardHeaderStyle}>
                <h3 style={cardTitleStyle}>{t('pos_access')}</h3>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 14 }}>
                <FieldRow label={t('cashier_access')}>
                    <span style={{ fontSize: 11, fontWeight: 600, borderRadius: 5, padding: '2px 8px', background: a.is_cashier ? C.greenLight : '#f1f5f9', color: a.is_cashier ? C.green : C.muted }}>
                        {a.is_cashier ? t('enabled') : t('disabled')}
                    </span>
                </FieldRow>
                <FieldRow label={t('pin')}>
                    {a.has_pin
                        ? <span style={{ fontFamily: 'monospace', letterSpacing: 3 }}>••••••</span>
                        : '—'}
                </FieldRow>
                <FieldRow label={t('preferred_language')}>
                    {employee.personal?.preferred_language
                        ? t(LANGUAGES.find(l => l.value === employee.personal.preferred_language)?.labelKey || 'english')
                        : '—'}
                </FieldRow>
            </div>
        </div>
    );
};

// ─── Portal Access card ──────────────────────────────────────────────────────


// ─── Main export ──────────────────────────────────────────────────────────────

const TabAccess = ({ employee, t }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <PosAccessCard employee={employee} t={t} />
    </div>
);

export default TabAccess;
